/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Patient } from '../models/patient';
import { SamlLoginRespose } from '../models/saml-login-respose';
import { ssoGetSamlLogin } from '../fn/sso/sso-get-saml-login';
import { SsoGetSamlLogin$Params } from '../fn/sso/sso-get-saml-login';
import { ssoReceiveSamlRequest } from '../fn/sso/sso-receive-saml-request';
import { SsoReceiveSamlRequest$Params } from '../fn/sso/sso-receive-saml-request';
import { ssoSamlManagerSamlAction } from '../fn/sso/sso-saml-manager-saml-action';
import { SsoSamlManagerSamlAction$Params } from '../fn/sso/sso-saml-manager-saml-action';
import { ssoSetPatientContext } from '../fn/sso/sso-set-patient-context';
import { SsoSetPatientContext$Params } from '../fn/sso/sso-set-patient-context';

@Injectable({ providedIn: 'root' })
export class SsoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ssoSamlManagerSamlAction()` */
  static readonly SsoSamlManagerSamlActionPath = '/SAMLManager/SamlAction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ssoSamlManagerSamlAction()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ssoSamlManagerSamlAction$Response(params?: SsoSamlManagerSamlAction$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return ssoSamlManagerSamlAction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ssoSamlManagerSamlAction$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ssoSamlManagerSamlAction(params?: SsoSamlManagerSamlAction$Params, context?: HttpContext): Observable<Blob> {
    return this.ssoSamlManagerSamlAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `ssoReceiveSamlRequest()` */
  static readonly SsoReceiveSamlRequestPath = '/SSO/saml/auth';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ssoReceiveSamlRequest()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ssoReceiveSamlRequest$Response(params?: SsoReceiveSamlRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return ssoReceiveSamlRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ssoReceiveSamlRequest$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ssoReceiveSamlRequest(params?: SsoReceiveSamlRequest$Params, context?: HttpContext): Observable<Blob> {
    return this.ssoReceiveSamlRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `ssoGetSamlLogin()` */
  static readonly SsoGetSamlLoginPath = '/SSO/saml/GetSAMLLogin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ssoGetSamlLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  ssoGetSamlLogin$Response(params?: SsoGetSamlLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<SamlLoginRespose>> {
    return ssoGetSamlLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ssoGetSamlLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ssoGetSamlLogin(params?: SsoGetSamlLogin$Params, context?: HttpContext): Observable<SamlLoginRespose> {
    return this.ssoGetSamlLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<SamlLoginRespose>): SamlLoginRespose => r.body)
    );
  }

  /** Path part for operation `ssoSetPatientContext()` */
  static readonly SsoSetPatientContextPath = '/SSO/saml/setPatientContext';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ssoSetPatientContext()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ssoSetPatientContext$Response(params: SsoSetPatientContext$Params, context?: HttpContext): Observable<StrictHttpResponse<Patient>> {
    return ssoSetPatientContext(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ssoSetPatientContext$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ssoSetPatientContext(params: SsoSetPatientContext$Params, context?: HttpContext): Observable<Patient> {
    return this.ssoSetPatientContext$Response(params, context).pipe(
      map((r: StrictHttpResponse<Patient>): Patient => r.body)
    );
  }

}
